import { createFileRoute, Outlet } from "@tanstack/react-router";

import { Inbox } from "~/components/messaging/inbox";
import { helpVideosQueryOptions } from "~/lib/queries/learningQuery";

export const Route = createFileRoute("/_user/messages")({
  staticData: { title: "Messages" },
  // The "How this works" button; a failed read only leaves it out.
  loader: async ({ context }) => {
    await context.queryClient
      .ensureQueryData(helpVideosQueryOptions())
      .catch(() => undefined);
  },
  component: MessagesLayout,
});

function MessagesLayout(): React.JSX.Element {
  return (
    <div className="-mx-4 -my-4 h-[calc(100dvh-3.5rem)] overflow-hidden md:-mx-6 md:-my-6">
      <Inbox />
      <Outlet />
    </div>
  );
}
